export default "__VITE_ASSET__DaNzkFgo__"